import { __awaiter } from "tslib";
import addUrlParams from 'pathfinder/modules/DiscoveryModules/shared/addUrlParams';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import { DiscussionVariant } from 'pathfinder/rules-engine/modules/discoveryModules';
import waitForOptimizely, { getOptimizelyValue } from 'pathfinder/utils/waitForOptimizely';
import React from 'react';
import ReactDOM from 'react-dom';
import { isThemeDark } from 'utils/getWikiInfo';
import getDiscussionThread from './modules/DiscoveryModuleInlineDiscussionCard/helpers/getDiscussionThread';
import { INLINE_DISCUSSION_CARD } from './modules/DiscoveryModuleInlineDiscussionCard/optimizely';
import placementHelper from './modules/DiscoveryModuleInlinePushToDiscussionsArticle/helpers/placementHelper';
export const getDiscoveryModuleInlineDiscussionCardMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log } = moduleProps;
    const isDesktop = moduleProps.config.variant === DiscussionVariant.DESKTOP;
    const deviceType = moduleProps.config.variant;
    // override values if foced
    const defaultValues = moduleConfig.internalState.forced
        ? {
            buttonLink: '/f',
            buttonText: 'Discuss',
            descriptionText: 'Have a question? Ask in our Fandom Discussions',
            headerText: 'Current Discussions',
        }
        : {
        /* no default values for non-forced module */
        };
    try {
        const reactRoot = document.createElement('div');
        // API
        const show = () => (reactRoot.style.display = '');
        const hide = () => (reactRoot.style.display = 'none');
        if (!isForced) {
            yield waitForOptimizely();
        }
        // read values from optimizely (with fallback)
        moduleProps.headerText = getOptimizelyValue(INLINE_DISCUSSION_CARD.HEADER_TEXT, defaultValues.headerText);
        moduleProps.buttonText = getOptimizelyValue(INLINE_DISCUSSION_CARD.BUTTON_TEXT, defaultValues.buttonText);
        moduleProps.buttonLink = addUrlParams(getOptimizelyValue(INLINE_DISCUSSION_CARD.BUTTON_LINK, defaultValues.buttonLink));
        moduleProps.descriptionText = getOptimizelyValue(INLINE_DISCUSSION_CARD.DESCRIPTION_TEXT, defaultValues.descriptionText);
        // validate values from Optmizely
        if (!moduleProps.descriptionText || !moduleProps.buttonText || !moduleProps.buttonLink || !moduleProps.headerText) {
            log.debug('Missing values from Optimizely', moduleProps);
            // fail silenty if values are missing
            return null;
        }
        else {
            log.debug('Successfully read values from Optimizely', moduleProps);
        }
        const discussion = yield getDiscussionThread();
        if (!discussion) {
            return null;
        }
        moduleProps.discussionPost = discussion;
        moduleProps.isDarkTheme = yield isThemeDark();
        moduleProps.isDesktop = isDesktop;
        const DiscoveryModuleInlineDiscussionCard = isDesktop
            ? yield import(
            /* webpackChunkName: "DiscoveryModuleInlineDiscussionCardDesktop" */ './modules/DiscoveryModuleInlineDiscussionCard/DiscoveryModuleInlineDiscussionCardDesktop')
            : yield import(
            /* webpackChunkName: "DiscoveryModuleInlineDiscussionCardMobile" */ './modules/DiscoveryModuleInlineDiscussionCard/DiscoveryModuleInlineDiscussionCardMobile');
        const render = () => {
            ReactDOM.render(React.createElement(DiscoveryModuleInlineDiscussionCard.default, moduleProps), reactRoot);
            return reactRoot;
        };
        const isInserted = placementHelper(moduleProps, reactRoot, isForced, deviceType);
        return isInserted
            ? {
                render,
                show,
                hide,
            }
            : null;
    }
    catch (error) {
        log.debug('DiscoveryModuleInlineDiscussionCard error', error);
    }
    return null;
});
